import moment from "moment";

export const formatToLocalDate = (utcDate) => {
    if (!utcDate) return "-";

    return new Date(utcDate).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "2-digit",
    });
};

export const getRemainingDays = (createdAtUTC, expiryDaysStr) => {
  const expiryDays = Number(expiryDaysStr);

  // Parse UTC date
  const createdAtUTCDate = new Date(createdAtUTC);

  // Convert to LOCAL date (same instant, local clock)
  const createdAtLocal = new Date(
    createdAtUTCDate.getFullYear(),
    createdAtUTCDate.getMonth(),
    createdAtUTCDate.getDate(),
    createdAtUTCDate.getHours(),
    createdAtUTCDate.getMinutes(),
    createdAtUTCDate.getSeconds()
  );

  // Calculate expiry date in LOCAL time
  const expiryDateLocal = new Date(createdAtLocal);
  expiryDateLocal.setDate(expiryDateLocal.getDate() + expiryDays);

  // Current LOCAL time
  const nowLocal = new Date();

  // Difference in days (calendar-friendly)
  const diffMs = expiryDateLocal - nowLocal;
  const remainingDays = Math.max(
    Math.ceil(diffMs / (1000 * 60 * 60 * 24)),
    0
  );

  return remainingDays;
};

export const getExpDate = (createdAtUTC, expiryDaysStr) => {
  const expiryDays = Number(expiryDaysStr);

  // Parse the UTC date
  const createdAtUTCDate = new Date(createdAtUTC);

  // Create a date in LOCAL time (same instant)
  const createdAtLocal = new Date(
    createdAtUTCDate.getFullYear(),
    createdAtUTCDate.getMonth(),
    createdAtUTCDate.getDate(),
    createdAtUTCDate.getHours(),
    createdAtUTCDate.getMinutes(),
    createdAtUTCDate.getSeconds()
  );

  // Calculate expiry date in LOCAL time
  const expiryDateLocal = new Date(createdAtLocal);
  expiryDateLocal.setDate(expiryDateLocal.getDate() + expiryDays);

   return moment(expiryDateLocal).format("DD/MM/YY");
};


export const formatAmount = (value) => {
  if (value === null || value === undefined || value === "" || isNaN(value)) {
    return "N/A";
  }
  return `$${Number(value).toFixed(2)}`;
};